// A site was added, renamed or switched on/off. The header's site count and the
// structure tree each load their own copy of the sites, so they listen for this rather
// than staying stale until the next full reload.
const EVENT = 'scribelive:sites-changed';

export const announceSitesChanged = () => window.dispatchEvent(new Event(EVENT));

export function onSitesChanged(fn) {
  window.addEventListener(EVENT, fn);
  return () => window.removeEventListener(EVENT, fn);
}
